"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardsAPIApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var RewardsAPIApi = /** @class */ (function (_super) {
    __extends(RewardsAPIApi, _super);
    function RewardsAPIApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create action.
     * Create action.
     */
    RewardsAPIApi.prototype.createActionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createActionRequest === null || requestParameters.createActionRequest === undefined) {
                            throw new runtime.RequiredError('createActionRequest', 'Required parameter requestParameters.createActionRequest was null or undefined when calling createAction.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/actions",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.CreateActionRequestToJSON)(requestParameters.createActionRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CreateAction201ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create action.
     * Create action.
     */
    RewardsAPIApi.prototype.createAction = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createActionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create entry.
     * Create entry.
     */
    RewardsAPIApi.prototype.createEntryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createEntryRequest === null || requestParameters.createEntryRequest === undefined) {
                            throw new runtime.RequiredError('createEntryRequest', 'Required parameter requestParameters.createEntryRequest was null or undefined when calling createEntry.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/entries",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.CreateEntryRequestToJSON)(requestParameters.createEntryRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CreateEntry201ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create entry.
     * Create entry.
     */
    RewardsAPIApi.prototype.createEntry = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createEntryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a Giveaway for a specific Creator. Only Creators can create Giveaways.
     * Create a giveaway
     */
    RewardsAPIApi.prototype.createGiveawayRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createGiveawayRequest === null || requestParameters.createGiveawayRequest === undefined) {
                            throw new runtime.RequiredError('createGiveawayRequest', 'Required parameter requestParameters.createGiveawayRequest was null or undefined when calling createGiveaway.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/giveaways",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.CreateGiveawayRequestToJSON)(requestParameters.createGiveawayRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CreateGiveaway201ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a Giveaway for a specific Creator. Only Creators can create Giveaways.
     * Create a giveaway
     */
    RewardsAPIApi.prototype.createGiveaway = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createGiveawayRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a giveaway scheduler config.
     * Creates a giveaway scheduler config.
     */
    RewardsAPIApi.prototype.createGiveawaySchedulerConfigRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createGiveawaySchedulerConfigRequest === null || requestParameters.createGiveawaySchedulerConfigRequest === undefined) {
                            throw new runtime.RequiredError('createGiveawaySchedulerConfigRequest', 'Required parameter requestParameters.createGiveawaySchedulerConfigRequest was null or undefined when calling createGiveawaySchedulerConfig.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/giveaway-scheduler/configs",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.CreateGiveawaySchedulerConfigRequestToJSON)(requestParameters.createGiveawaySchedulerConfigRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CreateGiveawaySchedulerConfig200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a giveaway scheduler config.
     * Creates a giveaway scheduler config.
     */
    RewardsAPIApi.prototype.createGiveawaySchedulerConfig = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createGiveawaySchedulerConfigRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create voucher.
     * Create voucher.
     */
    RewardsAPIApi.prototype.createVoucherRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createVoucherRequest === null || requestParameters.createVoucherRequest === undefined) {
                            throw new runtime.RequiredError('createVoucherRequest', 'Required parameter requestParameters.createVoucherRequest was null or undefined when calling createVoucher.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/vouchers",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.CreateVoucherRequestToJSON)(requestParameters.createVoucherRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CreateVoucher201ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create voucher.
     * Create voucher.
     */
    RewardsAPIApi.prototype.createVoucher = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createVoucherRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete action.
     * Delete action.
     */
    RewardsAPIApi.prototype.deleteActionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.actionId === null || requestParameters.actionId === undefined) {
                            throw new runtime.RequiredError('actionId', 'Required parameter requestParameters.actionId was null or undefined when calling deleteAction.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/actions/{actionId}".replace("{".concat("actionId", "}"), encodeURIComponent(String(requestParameters.actionId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete action.
     * Delete action.
     */
    RewardsAPIApi.prototype.deleteAction = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteActionRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes entry.
     * Deletes entry.
     */
    RewardsAPIApi.prototype.deleteEntryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
                            throw new runtime.RequiredError('entryId', 'Required parameter requestParameters.entryId was null or undefined when calling deleteEntry.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/entries/{entryId}".replace("{".concat("entryId", "}"), encodeURIComponent(String(requestParameters.entryId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Deletes entry.
     * Deletes entry.
     */
    RewardsAPIApi.prototype.deleteEntry = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteEntryRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes a Giveaway. Only Creators can delete Giveaways.
     * Delete a giveaway
     */
    RewardsAPIApi.prototype.deleteGiveawayRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.giveawayId === null || requestParameters.giveawayId === undefined) {
                            throw new runtime.RequiredError('giveawayId', 'Required parameter requestParameters.giveawayId was null or undefined when calling deleteGiveaway.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/giveaways/{giveawayId}".replace("{".concat("giveawayId", "}"), encodeURIComponent(String(requestParameters.giveawayId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Deletes a Giveaway. Only Creators can delete Giveaways.
     * Delete a giveaway
     */
    RewardsAPIApi.prototype.deleteGiveaway = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteGiveawayRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes a giveaway scheduler config.
     * Deletes a giveaway scheduler config.
     */
    RewardsAPIApi.prototype.deleteGiveawaySchedulerConfigRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteGiveawaySchedulerConfig.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/giveaway-scheduler/configs/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Deletes a giveaway scheduler config.
     * Deletes a giveaway scheduler config.
     */
    RewardsAPIApi.prototype.deleteGiveawaySchedulerConfig = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteGiveawaySchedulerConfigRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Return action.
     * Get all action.
     */
    RewardsAPIApi.prototype.getActionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.actionId === null || requestParameters.actionId === undefined) {
                            throw new runtime.RequiredError('actionId', 'Required parameter requestParameters.actionId was null or undefined when calling getAction.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/actions/{actionId}".replace("{".concat("actionId", "}"), encodeURIComponent(String(requestParameters.actionId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CreateAction201ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Return action.
     * Get all action.
     */
    RewardsAPIApi.prototype.getAction = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getActionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Return actions.
     * Get all actions.
     */
    RewardsAPIApi.prototype.getActionsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.strategyIds) {
                            queryParameters['strategyIds'] = requestParameters.strategyIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/actions",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GetActions200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Return actions.
     * Get all actions.
     */
    RewardsAPIApi.prototype.getActions = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getActionsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Return entries.
     * Get all entries.
     */
    RewardsAPIApi.prototype.getEntriesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.giveawayId !== undefined) {
                            queryParameters['giveawayId'] = requestParameters.giveawayId;
                        }
                        if (requestParameters.actionId !== undefined) {
                            queryParameters['actionId'] = requestParameters.actionId;
                        }
                        if (requestParameters.participantId !== undefined) {
                            queryParameters['participantId'] = requestParameters.participantId;
                        }
                        if (requestParameters.strategyIds) {
                            queryParameters['strategyIds'] = requestParameters.strategyIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/entries",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GetEntries200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Return entries.
     * Get all entries.
     */
    RewardsAPIApi.prototype.getEntries = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEntriesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Return single Giveaway object.
     * Get one Giveaway
     */
    RewardsAPIApi.prototype.getGiveawayRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.giveawayId === null || requestParameters.giveawayId === undefined) {
                            throw new runtime.RequiredError('giveawayId', 'Required parameter requestParameters.giveawayId was null or undefined when calling getGiveaway.');
                        }
                        queryParameters = {};
                        if (requestParameters.projection !== undefined) {
                            queryParameters['projection'] = requestParameters.projection;
                        }
                        if (requestParameters.as !== undefined) {
                            queryParameters['as'] = requestParameters.as;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/giveaways/{giveawayId}".replace("{".concat("giveawayId", "}"), encodeURIComponent(String(requestParameters.giveawayId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GetGiveaway200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Return single Giveaway object.
     * Get one Giveaway
     */
    RewardsAPIApi.prototype.getGiveaway = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGiveawayRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get giveaway scheduler config.
     * Get giveaway scheduler config.
     */
    RewardsAPIApi.prototype.getGiveawaySchedulerConfigRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getGiveawaySchedulerConfig.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/giveaway-scheduler/configs/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CreateGiveawaySchedulerConfig200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get giveaway scheduler config.
     * Get giveaway scheduler config.
     */
    RewardsAPIApi.prototype.getGiveawaySchedulerConfig = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGiveawaySchedulerConfigRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all giveaway scheduler configs.
     * Get giveaway scheduler configs.
     */
    RewardsAPIApi.prototype.getGiveawaySchedulerConfigsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.ownerId !== undefined) {
                            queryParameters['ownerId'] = requestParameters.ownerId;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/giveaway-scheduler/configs",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GetGiveawaySchedulerConfigs200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all giveaway scheduler configs.
     * Get giveaway scheduler configs.
     */
    RewardsAPIApi.prototype.getGiveawaySchedulerConfigs = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGiveawaySchedulerConfigsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns all giveaways depending on filtering criteria. This is multipurpose endpoint, it can be used to fetch all giveaways, with multiple filters.
     * Get all giveaways
     */
    RewardsAPIApi.prototype.getGiveawaysRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.ownerId !== undefined) {
                            queryParameters['ownerId'] = requestParameters.ownerId;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.projection !== undefined) {
                            queryParameters['projection'] = requestParameters.projection;
                        }
                        if (requestParameters.as !== undefined) {
                            queryParameters['as'] = requestParameters.as;
                        }
                        if (requestParameters.minEndDate !== undefined) {
                            queryParameters['minEndDate'] = requestParameters.minEndDate.toISOString();
                        }
                        if (requestParameters.maxEndDate !== undefined) {
                            queryParameters['maxEndDate'] = requestParameters.maxEndDate.toISOString();
                        }
                        if (requestParameters.sortBy !== undefined) {
                            queryParameters['sortBy'] = requestParameters.sortBy;
                        }
                        if (requestParameters.sortOrder !== undefined) {
                            queryParameters['sortOrder'] = requestParameters.sortOrder;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/giveaways",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GetGiveaways200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns all giveaways depending on filtering criteria. This is multipurpose endpoint, it can be used to fetch all giveaways, with multiple filters.
     * Get all giveaways
     */
    RewardsAPIApi.prototype.getGiveaways = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGiveawaysRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get giveaway aggregated statistics
     * Get giveaway aggregated statistics
     */
    RewardsAPIApi.prototype.getStatisticsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.ownerId !== undefined) {
                            queryParameters['ownerId'] = requestParameters.ownerId;
                        }
                        if (requestParameters.from !== undefined) {
                            queryParameters['from'] = requestParameters.from.toISOString();
                        }
                        if (requestParameters.to !== undefined) {
                            queryParameters['to'] = requestParameters.to.toISOString();
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/giveaway-statistics",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GetStatistics200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get giveaway aggregated statistics
     * Get giveaway aggregated statistics
     */
    RewardsAPIApi.prototype.getStatistics = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStatisticsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Return voucher.
     * Get one voucher.
     */
    RewardsAPIApi.prototype.getVoucherRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.voucherId === null || requestParameters.voucherId === undefined) {
                            throw new runtime.RequiredError('voucherId', 'Required parameter requestParameters.voucherId was null or undefined when calling getVoucher.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/vouchers/{voucherId}".replace("{".concat("voucherId", "}"), encodeURIComponent(String(requestParameters.voucherId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GetVoucher200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Return voucher.
     * Get one voucher.
     */
    RewardsAPIApi.prototype.getVoucher = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVoucherRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Return array of vouchers.
     * Get all vouchers.
     */
    RewardsAPIApi.prototype.getVouchersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.giveawayId !== undefined) {
                            queryParameters['giveawayId'] = requestParameters.giveawayId;
                        }
                        if (requestParameters.giveawayOwnerId !== undefined) {
                            queryParameters['giveawayOwnerId'] = requestParameters.giveawayOwnerId;
                        }
                        if (requestParameters.voucherParticipantId !== undefined) {
                            queryParameters['voucherParticipantId'] = requestParameters.voucherParticipantId;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/vouchers",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GetVouchers200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Return array of vouchers.
     * Get all vouchers.
     */
    RewardsAPIApi.prototype.getVouchers = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVouchersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Return number of vouchers.
     * Get vouchers count.
     */
    RewardsAPIApi.prototype.getVouchersCountRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.giveawayId !== undefined) {
                            queryParameters['giveawayId'] = requestParameters.giveawayId;
                        }
                        if (requestParameters.giveawayOwnerId !== undefined) {
                            queryParameters['giveawayOwnerId'] = requestParameters.giveawayOwnerId;
                        }
                        if (requestParameters.voucherParticipantId !== undefined) {
                            queryParameters['voucherParticipantId'] = requestParameters.voucherParticipantId;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/vouchers/count",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GetVouchersCount200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Return number of vouchers.
     * Get vouchers count.
     */
    RewardsAPIApi.prototype.getVouchersCount = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVouchersCountRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update Giveaway object.
     * Update Giveaway
     */
    RewardsAPIApi.prototype.updateGiveawayRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.giveawayId === null || requestParameters.giveawayId === undefined) {
                            throw new runtime.RequiredError('giveawayId', 'Required parameter requestParameters.giveawayId was null or undefined when calling updateGiveaway.');
                        }
                        if (requestParameters.updateGiveawayRequest === null || requestParameters.updateGiveawayRequest === undefined) {
                            throw new runtime.RequiredError('updateGiveawayRequest', 'Required parameter requestParameters.updateGiveawayRequest was null or undefined when calling updateGiveaway.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/giveaways/{giveawayId}".replace("{".concat("giveawayId", "}"), encodeURIComponent(String(requestParameters.giveawayId))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.UpdateGiveawayRequestToJSON)(requestParameters.updateGiveawayRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update Giveaway object.
     * Update Giveaway
     */
    RewardsAPIApi.prototype.updateGiveaway = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateGiveawayRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update a giveaway scheduler config.
     * Update a giveaway scheduler config.
     */
    RewardsAPIApi.prototype.updateGiveawaySchedulerConfigRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling updateGiveawaySchedulerConfig.');
                        }
                        if (requestParameters.updateGiveawaySchedulerConfigRequest === null || requestParameters.updateGiveawaySchedulerConfigRequest === undefined) {
                            throw new runtime.RequiredError('updateGiveawaySchedulerConfigRequest', 'Required parameter requestParameters.updateGiveawaySchedulerConfigRequest was null or undefined when calling updateGiveawaySchedulerConfig.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/giveaway-scheduler/configs/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.UpdateGiveawaySchedulerConfigRequestToJSON)(requestParameters.updateGiveawaySchedulerConfigRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CreateGiveawaySchedulerConfig200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update a giveaway scheduler config.
     * Update a giveaway scheduler config.
     */
    RewardsAPIApi.prototype.updateGiveawaySchedulerConfig = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateGiveawaySchedulerConfigRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update voucher.
     * Update voucher.
     */
    RewardsAPIApi.prototype.updateVoucherRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.voucherId === null || requestParameters.voucherId === undefined) {
                            throw new runtime.RequiredError('voucherId', 'Required parameter requestParameters.voucherId was null or undefined when calling updateVoucher.');
                        }
                        if (requestParameters.updateVoucherRequest === null || requestParameters.updateVoucherRequest === undefined) {
                            throw new runtime.RequiredError('updateVoucherRequest', 'Required parameter requestParameters.updateVoucherRequest was null or undefined when calling updateVoucher.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/vouchers/{voucherId}".replace("{".concat("voucherId", "}"), encodeURIComponent(String(requestParameters.voucherId))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.UpdateVoucherRequestToJSON)(requestParameters.updateVoucherRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update voucher.
     * Update voucher.
     */
    RewardsAPIApi.prototype.updateVoucher = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateVoucherRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update Giveaway statistics
     * Update Giveaway statistics
     */
    RewardsAPIApi.prototype.upsertStatisticsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.giveawayId === null || requestParameters.giveawayId === undefined) {
                            throw new runtime.RequiredError('giveawayId', 'Required parameter requestParameters.giveawayId was null or undefined when calling upsertStatistics.');
                        }
                        if (requestParameters.upsertStatisticsRequest === null || requestParameters.upsertStatisticsRequest === undefined) {
                            throw new runtime.RequiredError('upsertStatisticsRequest', 'Required parameter requestParameters.upsertStatisticsRequest was null or undefined when calling upsertStatistics.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/giveaway-statistics/{giveawayId}".replace("{".concat("giveawayId", "}"), encodeURIComponent(String(requestParameters.giveawayId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.UpsertStatisticsRequestToJSON)(requestParameters.upsertStatisticsRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update Giveaway statistics
     * Update Giveaway statistics
     */
    RewardsAPIApi.prototype.upsertStatistics = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.upsertStatisticsRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return RewardsAPIApi;
}(runtime.BaseAPI));
exports.RewardsAPIApi = RewardsAPIApi;
